import { AddRateCard } from '../../pages';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import { InventoryController } from '../../controllers';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';

const AddRateCardMainContainer = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);

	const validationSchema = () => {
		return yup.object({
			rateCards: yup.array(
				yup.object({
					title: yup.string().required('Title is required'),
					grade: yup.string().required('Grade is required'),
					sellingPrice: yup.number().min(1, 'Selling price should be greater than 1'),
					splitPercentage: yup.number().min(1, 'Split Percentage should be greater than 1'),
				})
			),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);

		const { status, errorMessage } = await InventoryController.createRateCards(payload);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<AddRateCard
			closeModal={closeModal}
			loading={loading}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
		/>
	);
};

export default observer(AddRateCardMainContainer);
